import { render, staticRenderFns } from "./CustomPoll.vue?vue&type=template&id=813849a2&scoped=true&"
import script from "./CustomPoll.vue?vue&type=script&lang=js&"
export * from "./CustomPoll.vue?vue&type=script&lang=js&"
import style0 from "./CustomPoll.vue?vue&type=style&index=0&id=813849a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813849a2",
  null
  
)

export default component.exports